import { SourceType } from '@/feature/patients/types';

export const FACESHEET_RECORD_TYPES = [
  'additionalReferenceDocument',
  'allergy',
  'demographic',
  'encounter',
  'familyHistory',
  'imagingNote',
  'labPanel',
  'labResult',
  'medication',
  'other',
  'pathologyResult',
  'problem',
  'procedure',
  'procedureNote',
  'provider',
  'providerFacilityNote',
  'socialHistory',
  'vaccination',
  'vital',
] as const;

export type FacesheetRecordType = (typeof FACESHEET_RECORD_TYPES)[number];

const FACESHEET_SOURCE_TYPE_MAP: Record<string, SourceType> = {
  providerFacilityRetrieval: SourceType.PROVIDER_FACILITY_RETRIEVAL,
  medicationsDigitalData: SourceType.MEDICATIONS_DIGITAL_DATA,
  digitalHealthDataHie: SourceType.HIE_DATA,
};

export const mapFacesheetSourceType = (
  sourceType: string | null | undefined,
): SourceType => {
  if (!sourceType) return SourceType.UNSPECIFIED;
  return FACESHEET_SOURCE_TYPE_MAP[sourceType] ?? SourceType.UNSPECIFIED;
};

export const isMedicationsDigitalData = (
  sourceType: string | null | undefined,
): boolean => sourceType === 'medicationsDigitalData';
